exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab-align {\r\n    margin-left: -7%\r\n}\r\n\r\n.radio-group-pad {\r\n    margin-top: 10px\r\n}\r\n.row-align {\r\n    padding-left: 20px\r\n}\r\n.container {\r\n    padding-left: 20px\r\n}\r\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/css-loader!F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/SystemServicesManager/system-service.component.css
 ** module id = 953
 ** module chunks = 2
 **/